import { render, staticRenderFns } from "./viewPayment.vue?vue&type=template&id=4bd04fb4&scoped=true&"
import script from "./viewPayment.vue?vue&type=script&lang=js&"
export * from "./viewPayment.vue?vue&type=script&lang=js&"
import style0 from "./viewPayment.vue?vue&type=style&index=0&id=4bd04fb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd04fb4",
  null
  
)

export default component.exports